import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';
import { OwnAiTitle } from '../../../OwnAI/components/Title';

export const ScreenStyles = styled(OnboardingPage)`
  padding: 24px;
`;

export const TitleStyles = styled(OwnAiTitle)`
  margin: 0 auto 26px;
`;

export const MainImgStyles = styled.div<{ $isKelly?: boolean }>`
  width: ${({ $isKelly }) => ($isKelly ? '343px' : '305px')};
  height: ${({ $isKelly }) => ($isKelly ? '439px' : '352px')};
  max-width: 100%;
  font-size: 0;
  line-height: 0;
  margin: 24px auto 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const OptionsContainerStyles = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
`;
